export const products = [
    {
      id: 1,
      img: "https://i.ibb.co/1qWJ5gf/screencapture-library-nodeapp-herokuapp-catalog-2022-05-17-15-44-53.png",
      link: "https://library-5ea0.onrender.com",
      title:"Library APP"
    },
    {
      id: 2,
      img: "https://i.ibb.co/WVsztNv/ecommerce.png",
      link: "https://documenter.getpostman.com/view/10682643/UyxhonQP",
      title:"Ecommerce API"
    },
    {
      id: 3,
      img: "https://i.ibb.co/fY8gx4T/merge-from-ofoct.jpg",
      link: "https://drive.google.com/file/d/13moAGYTssYAO7m-3RpIzgN-OO96G_Nsh/view?usp=sharing",
      title:"Medicament APP"
    },
    {
      id: 4,
      img: "https://i.ibb.co/Hgm9ZtL/booking.jpg",
      link: "https://booking-dun.vercel.app/",
      title:"Booking REACT"
    },
    {
      id: 5,
      img: "https://i.ibb.co/5hLQ8YR/maps.png",
      link: "https://maps-react-sable.vercel.app/",
      title:"Points REACT"
    },
    {
      id: 6,
      img: "https://i.ibb.co/k575sv3/portfolio.png",
      link: "https://github.com/EriVelk/portfolio",
      title:"Portfolio REACT"
    },
    {
      id: 7,
      img: "https://i.ibb.co/nm7GDq8/apimed.png",
      link: "https://github.com/EriVelk/medicaments-app",
      title:"API REST for Medicament APP"
    },
    {
      id: 8,
      img: "https://i.ibb.co/svt4wM0/app.jpg",
      link: "https://www.youtube.com/watch?v=iLpBzbO2BSI",
      title:"APP Android Security City"
    },
    {
      id: 8,
      img: "https://i.ibb.co/q5tJYZN/Selenium.png",
      link: "https://github.com/EriVelk/library-selenium",
      title:"Selenium Web Driver Project"
    },
  ];